import { FetchStatus } from '@tanstack/react-query';

export const checkIfIsLoading = (fetchStatus?: FetchStatus): boolean => {
  if (!fetchStatus) return false;
  return !(fetchStatus === ('idle' || 'error'));
};
